// Dto
import SeStoreDTO from "../dto/SeStoreDTO"

// Types
import { LocaleLodgingTypeConfig, LodgingTypeConfigValue } from '@/config/lodging-type-config'

// Helpers
import getLodgingTypesByLocale from '../../initScripts/getLodgingTypesByLocale'



const buildSearchEventLodgingTypeArr = (seStore: SeStoreDTO): string[] => {
    if(!seStore.lodgingType || !Array.isArray(seStore.lodgingType)) return []
    const configForLocale: LocaleLodgingTypeConfig = getLodgingTypesByLocale(window.locale)

    // Map of loding type and label
    const lodgingTypeLabelMap: Map<string, string> = new Map()

    // Assign the values to the map
    configForLocale.forEach(
        (
            item: {
                label: string;
                values: LodgingTypeConfigValue[];
            }
        ) =>  {
            const firstValue: LodgingTypeConfigValue =  item.values[0]
            if(!firstValue || !firstValue.id) return
            lodgingTypeLabelMap.set(firstValue.id, item.label)
        }
    )

    return seStore.lodgingType.map((lodgingType: string) => lodgingTypeLabelMap.get(lodgingType) || "")
}

export default buildSearchEventLodgingTypeArr